import { useShallow } from 'zustand/shallow';
import { CommentsState, store } from './store';

export const useComments = () => {
  const {
    data,
    loading,
    error,
    createComment,
    fetchComment,
    fetchComments,
    updateComment,
    reset,
    replyComment,
  } = store<CommentsState>(
    useShallow((state) => ({
      data: state.data,
      loading: state.loading,
      error: state.error,
      createComment: state.createComment,
      fetchComment: state.fetchComment,
      fetchComments: state.fetchComments,
      updateComment: state.updateComment,
      reset: state.reset,
      replyComment: state.replyComment,
    })),
  );

  return {
    data,
    loading,
    error,
    createComment,
    fetchComment,
    fetchComments,
    updateComment,
    reset,
    replyComment,
  };
};
